import _typeof from "./typeof.js";
export default function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/toPrimitive.js
// module id = 970
// module chunks = 1